t = require('app/scripts/views/internal/teacup-with-helpers')('move_card_controls')
{ SelectTestIds } = require '@trello/webdriverio-tests'

module.exports = ->
  t.mustacheBlockInverted 'hideBoard', ->
    t.div '.form-grid', ->
      t.div '.form-grid-child.form-grid-child-full', { class: t.classify({
        'hide': !t.mustacheVar('restrictToCurrentBoard')
      }) }, ->
        t.label ->
          t.format 'board'
        t.p ->
          t.mustacheBlock 'organizations', ->
            t.mustacheBlock 'boards', ->
              t.text t.mustacheVar('name')
      t.div '.button-link.setting.form-grid-child.form-grid-child-full', { class: t.classify({
        'hide': t.mustacheVar('restrictToCurrentBoard')
      }) }, ->
        t.span '.label', ->
          t.format 'board'
        t.span '.value.js-board-value'
        t.label ->
          t.format 'board'
        t.select '.js-select-board', {
          'data-test-id': SelectTestIds.MoveBoardSelect
        }, ->
          t.mustacheBlock 'organizations', ->
            t.optgroup { label: t.mustacheVar('displayName') }, ->
              t.mustacheBlock 'boards', ->
                t.optionSelected t.mustacheVar('selected'), { value: t.mustacheVar('id') }, ->
                  t.text t.mustacheVar('name')
                  t.mustacheBlock 'selected', ->
                    t.text ' '
                    t.format 'current'

    t.mustacheBlock 'hasEnterprise', ->
      t.mustacheBlock 'enterpriseName', ->
        t.mustacheBlock 'isMove', ->
          t.p '.quiet', ->
            t.format('card-can-only-be-moved-to-teams-within-org', { enterpriseName: t.mustacheVar('enterpriseName') })
        t.mustacheBlock 'isCopy', ->
          t.p '.quiet', ->
            t.format('card-can-only-be-copied-to-teams-within-org', { enterpriseName: t.mustacheVar('enterpriseName') })

  t.div '.form-grid', ->

    t.div '.button-link.setting.form-grid-child.form-grid-child-threequarters', ->
      t.span '.label', ->
        t.format 'list'
      t.span '.value.js-list-value'
      t.label ->
        t.format 'list'
      t.select '.js-select-list'

    t.div '.button-link.setting.form-grid-child', ->
      t.span '.label', ->
        t.format 'position'
      t.span '.value.js-pos-value'
      t.label ->
        t.format 'position'
      t.select '.js-select-position'
